/* Candili: sacola lateral e página /cart (10/10/2026).
   Quantidade, remover, cupom e observação. Depois de cada mudança pede as seções de novo
   (cart-drawer, a seção da página e o contador do topo) e troca o conteúdo. */
(function () {
  if (window.cdlSacola) return;

  var J = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var msgCupom = null;

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: J, body: JSON.stringify(body) }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, d: d }; });
    });
  }
  function lerCarrinho() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function doc(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function atualizar(cart) {
    var ids = [];
    var gaveta = document.querySelector('cart-drawer');
    var pagina = document.querySelector('[data-cdl-sc="pagina"]');
    if (gaveta) ids.push('cart-drawer');
    if (pagina && pagina.getAttribute('data-sid')) ids.push(pagina.getAttribute('data-sid'));
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    if (!ids.length) return Promise.resolve();

    /* A seção é desenhada no contexto da página: a gaveta só existe fora de /cart. */
    var base = pagina ? '/cart' : window.location.pathname;
    return fetch(base + '?sections=' + ids.join(',') + '&_=' + Date.now())
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (gaveta) {
          var gid = 'cart-drawer';
          var dg = s[gid] && doc(s[gid]);
          var novo = dg && dg.querySelector('.drawer__inner');
          var atual = gaveta.querySelector('.drawer__inner');
          if (novo && atual) {
            var abertos = abertosEm(atual);
            atual.innerHTML = novo.innerHTML;
            reabrir(atual, abertos);
          }
          var ng = dg && dg.querySelector('cart-drawer');
          if (ng) gaveta.classList.toggle('is-empty', ng.classList.contains('is-empty'));
        }
        if (pagina) {
          var dp = s[pagina.getAttribute('data-sid')] && doc(s[pagina.getAttribute('data-sid')]);
          var np = dp && dp.querySelector('[data-cdl-sc="pagina"]');
          if (np) {
            var ab = abertosEm(pagina);
            pagina.replaceWith(np);
            reabrir(np, ab);
            fixa();
          }
        }
        var bolha = document.getElementById('cart-icon-bubble');
        if (bolha && s['cart-icon-bubble']) {
          var db = doc(s['cart-icon-bubble']).querySelector('.shopify-section');
          if (db) bolha.innerHTML = db.innerHTML;
        }
        /* o conteúdo foi trocado: o campo que estava em foco deixou de existir, então o rodapé volta */
        document.documentElement.classList.remove('cdl-digitando');
        if (msgCupom) { mostrarMsgCupom(msgCupom); msgCupom = null; }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cdl-sacola', cartData: cart || null }); } catch (e) {}
        }
        document.dispatchEvent(new CustomEvent('cdl:sacola'));
      })
      .catch(function (e) { console.error(e); });
  }

  /* Mantém aberto o que a cliente tinha aberto (cupom, observação) depois de trocar o conteúdo. */
  function abertosEm(el) {
    return [].map.call(el.querySelectorAll('details.cdl-sc__dt'), function (d) { return d.open; });
  }
  function reabrir(el, lista) {
    [].forEach.call(el.querySelectorAll('details.cdl-sc__dt'), function (d, i) { if (lista[i]) d.open = true; });
  }

  function carregando(on) {
    document.querySelectorAll('[data-cdl-sc]').forEach(function (el) { el.classList.toggle('is-load', on); });
  }

  function mudarQtd(btn) {
    var key = btn.getAttribute('data-key');
    var q = parseInt(btn.getAttribute('data-cdl-q'), 10);
    carregando(true);
    post('/cart/change.js', { id: key, quantity: q }).then(function (res) {
      if (!res.ok) {
        var err = document.querySelector('[data-cdl-err="' + key + '"]');
        if (err) { err.textContent = (res.d && (res.d.description || res.d.message)) || 'Não foi possível mudar a quantidade.'; err.hidden = false; }
        /* linha que já não existe (sacola mudou em outra aba/checkout): redesenha com a sacola real */
        lerCarrinho().then(atualizar).catch(function () {});
        carregando(false);
        return;
      }
      return atualizar(res.d);
    }).finally(function () { carregando(false); });
  }

  /* "Trocar por este kit": põe o kit e tira as peças avulsas (não soma, para não cobrar em dobro).
     O kit guarda, na propriedade oculta _trocou, quais peças ela tinha (produto:variação); a sacola
     usa isso para oferecer a peça avulsa de volta como 1ª sugestão. */
  function aindaNaSacola(cart, keys) {
    return (cart.items || []).filter(function (i) { return keys.indexOf(i.key) >= 0; });
  }
  function removerAvulsas(keys, vids) {
    var obj = {};
    keys.forEach(function (k) { obj[k] = 0; });
    return post('/cart/update.js', { updates: obj }).then(function (res) {
      if (res.ok && !aindaNaSacola(res.d, keys).length) return;
      /* plano B: uma a uma, pela chave */
      var seq = Promise.resolve();
      keys.forEach(function (k) { seq = seq.then(function () { return post('/cart/change.js', { id: k, quantity: 0 }); }); });
      return seq.then(lerCarrinho).then(function (cart) {
        if (!aindaNaSacola(cart, keys).length) return;
        /* plano C: pela variação */
        var o2 = {};
        vids.forEach(function (v) { o2[v] = 0; });
        return post('/cart/update.js', { updates: o2 });
      });
    }).then(lerCarrinho).then(function (cart) {
      if (aindaNaSacola(cart, keys).length) throw new Error('O kit foi adicionado, mas não conseguimos tirar a peça avulsa. Use "Remover" na peça.');
    });
  }
  function trocarPorKit(btn) {
    var vid = parseInt(btn.getAttribute('data-variant'), 10);
    var keys = (btn.getAttribute('data-linhas') || '').split(',').filter(Boolean);
    var vids = (btn.getAttribute('data-variantes') || '').split(',').filter(Boolean);
    var prods = btn.getAttribute('data-produtos') || '';
    var box = btn.closest('[data-cdl-tk]');
    var err = box && box.querySelector('[data-cdl-tk-err]');
    if (!vid || !keys.length) return;
    btn.disabled = true;
    btn.textContent = 'Trocando…';
    if (err) err.hidden = true;
    /* primeiro põe o kit: se faltar estoque, a sacola não perde as peças que a cliente já tinha */
    post('/cart/add.js', { items: [{ id: vid, quantity: 1, properties: { '_origem': 'sacola-kit', '_trocou': prods } }] }).then(function (res) {
      if (!res.ok) throw new Error((res.d && (res.d.description || res.d.message)) || 'Não foi possível adicionar o kit.');
      return removerAvulsas(keys, vids);
    }).then(function () { return atualizar(); })
      .catch(function (e) {
        var msg = e.message || 'Não foi possível trocar agora. Tente de novo.';
        /* a sacola é desenhada de novo; o aviso vai para o cartão novo */
        atualizar().then(function () {
          var e2 = document.querySelector('[data-cdl-tk-err]');
          if (e2) { e2.textContent = msg; e2.hidden = false; }
        });
      });
  }
  /* 14/10: bump das fraldinhas sortidas (snippets/cdl-bump-fraldinhas). O preço especial vem do desconto automático. */
  function addBump(btn) {
    var box = btn.closest('[data-cdl-ob-box]');
    var sel = box && box.querySelector('[data-cdl-ob-v]');
    var err = box && box.querySelector('[data-cdl-ob-err]');
    var vid = sel && parseInt(sel.value, 10);
    if (!vid) return;
    btn.disabled = true;
    btn.textContent = 'Adicionando…';
    if (err) err.hidden = true;
    post('/cart/add.js', { items: [{ id: vid, quantity: 1, properties: { '_origem': 'sacola-bump' } }] }).then(function (res) {
      if (!res.ok) throw new Error((res.d && (res.d.description || res.d.message)) || 'Não foi possível adicionar agora.');
      return atualizar();
    }).catch(function (e) {
      btn.disabled = false;
      btn.textContent = 'Tentar de novo';
      if (err) { err.textContent = e.message; err.hidden = false; }
    });
  }
  function codigosValidos(cart) {
    return (cart.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
  }

  function mostrarMsgCupom(t) {
    document.querySelectorAll('[data-cdl-cp]').forEach(function (d) {
      d.open = true;
      var p = d.querySelector('[data-cdl-cp-msg]');
      if (p) { p.textContent = t; p.hidden = false; }
    });
  }

  function aplicarCupom(box) {
    var inp = box.querySelector('[data-cdl-cp-in]');
    var code = (inp && inp.value || '').trim();
    if (!code) { if (inp) inp.focus(); return; }
    carregando(true);
    lerCarrinho().then(function (cart) {
      var lista = codigosValidos(cart).filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      lista.push(code);
      return post('/cart/update.js', { discount: lista.join(',') });
    }).then(function (res) {
      var cart = res.d || {};
      var achado = (cart.discount_codes || []).filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
      if (achado && achado.applicable) return atualizar(cart);
      msgCupom = 'Esse cupom não vale para esta sacola. Confira se digitou certinho.';
      return post('/cart/update.js', { discount: codigosValidos(cart).join(',') }).then(function (r2) { return atualizar(r2.d); });
    }).catch(function (e) { console.error(e); mostrarMsgCupom('Não foi possível aplicar agora. Tente de novo em instantes.'); })
      .finally(function () { carregando(false); });
  }

  function removerCupom(code) {
    carregando(true);
    lerCarrinho().then(function (cart) {
      var lista = (cart.discount_codes || []).map(function (c) { return c.code; })
        .filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      return post('/cart/update.js', { discount: lista.join(',') });
    }).then(function (res) { return atualizar(res.d); })
      .finally(function () { carregando(false); });
  }

  var tNota = null;
  function salvarNota(el) {
    clearTimeout(tNota);
    tNota = setTimeout(function () {
      post('/cart/update.js', { note: el.value }).then(function () {
        var ok = el.parentNode.querySelector('[data-cdl-nota-ok]');
        if (ok) { ok.hidden = false; setTimeout(function () { ok.hidden = true; }, 2000); }
      });
    }, 500);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cdl-q],[data-cdl-cp-ap],[data-cdl-cp-rm],[data-cdl-fechar],[data-cdl-fx-btn],[data-cdl-troca],[data-cdl-ob]');
    if (!t) return;
    if (t.hasAttribute('data-cdl-ob')) { e.preventDefault(); addBump(t); }
    else if (t.hasAttribute('data-cdl-troca')) { e.preventDefault(); trocarPorKit(t); }
    else if (t.hasAttribute('data-cdl-q')) { e.preventDefault(); mudarQtd(t); }
    else if (t.hasAttribute('data-cdl-cp-ap')) { e.preventDefault(); aplicarCupom(t.closest('[data-cdl-cp]')); }
    else if (t.hasAttribute('data-cdl-cp-rm')) { e.preventDefault(); removerCupom(t.getAttribute('data-cdl-cp-rm')); }
    else if (t.hasAttribute('data-cdl-fechar')) { var g = t.closest('cart-drawer'); if (g && g.close) g.close(); }
    else if (t.hasAttribute('data-cdl-fx-btn')) { var b = document.querySelector('[data-cdl-sc="pagina"] [data-cdl-checkout]'); if (b) b.click(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-cdl-cp-in]')) { e.preventDefault(); aplicarCupom(e.target.closest('[data-cdl-cp]')); }
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-cdl-nota]')) salvarNota(e.target);
  });
  /* Página /cart no celular: barra fixa com total e "Finalizar compra" quando o resumo sai da tela. */
  var obs = null;
  function fixa() {
    var res = document.querySelector('[data-cdl-sc="pagina"] [data-cdl-res]');
    var fx = document.querySelector('[data-cdl-sc="pagina"] [data-cdl-fx]');
    if (obs) { obs.disconnect(); obs = null; }
    if (!res || !fx || !('IntersectionObserver' in window)) return;
    obs = new IntersectionObserver(function (en) {
      var vis = en[0].isIntersecting;
      fx.classList.toggle('is-on', !vis);
      fx.setAttribute('aria-hidden', vis ? 'true' : 'false');
    });
    obs.observe(res.querySelector('[data-cdl-checkout]') || res);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixa); else fixa();

  /* Voltar do checkout (botão "voltar" do navegador): a página vem do cache com linhas antigas e
     o "Remover"/"+"/"-" dava "nenhum parâmetro de linha ou id válido". Ao reaparecer, relê a sacola. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) lerCarrinho().then(atualizar).catch(function () {});
  });

  /* Celular: ao tocar no cupom ou na observação, o teclado abre e o rodapé fixo subiria junto,
     cobrindo o campo. Enquanto digita, o rodapé some (classe cdl-digitando) e o campo vai para o meio. */
  var celular = window.matchMedia('(max-width: 989px)');
  var tSai = null;
  function campoDaSacola(el) { return el && el.matches && el.matches('[data-cdl-cp-in],[data-cdl-nota]'); }
  document.addEventListener('focusin', function (e) {
    if (!celular.matches || !campoDaSacola(e.target)) return;
    clearTimeout(tSai);
    document.documentElement.classList.add('cdl-digitando');
    var el = e.target;
    ajustarTela();
    /* o teclado leva um tempo para abrir: confere de novo depois, até a tela se acomodar */
    [250, 600, 1000].forEach(function (ms) { setTimeout(function () { ajustarTela(); mostrar(el); }, ms); });
  });
  var vv = window.visualViewport;
  function ajustarTela() {
    if (!vv) return;
    var r = document.documentElement.style;
    r.setProperty('--cdl-vvh', vv.height + 'px');
    r.setProperty('--cdl-vvt', vv.offsetTop + 'px');
  }
  function mostrar(el) {
    if (!document.documentElement.classList.contains('cdl-digitando') || document.activeElement !== el) return;
    try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) { el.scrollIntoView(); }
  }
  if (vv) {
    var tVv = null;
    var aoMudar = function () {
      if (!document.documentElement.classList.contains('cdl-digitando')) return;
      ajustarTela();
      clearTimeout(tVv);
      tVv = setTimeout(function () { mostrar(document.activeElement); }, 120);
    };
    vv.addEventListener('resize', aoMudar);
    vv.addEventListener('scroll', aoMudar);
  }
  document.addEventListener('focusout', function (e) {
    if (!campoDaSacola(e.target)) return;
    /* espera um pouco: o toque em "Aplicar" acontece logo depois de o campo perder o foco */
    tSai = setTimeout(function () {
      if (!campoDaSacola(document.activeElement)) { document.documentElement.classList.remove('cdl-digitando'); document.documentElement.style.removeProperty('--cdl-vvh'); document.documentElement.style.removeProperty('--cdl-vvt'); }
    }, 300);
  });

  window.cdlSacola = { atualizar: atualizar };
})();
